import { render, staticRenderFns } from "./FacilityPage.vue?vue&type=template&id=1a0dd496&scoped=true&"
import script from "./FacilityPage.vue?vue&type=script&lang=ts&"
export * from "./FacilityPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0dd496",
  null
  
)

export default component.exports